import {get, post, del, put} from '@/api';
import * as MEDICINE from '../constants/medicine';
import queryString from "query-string";

export default {
  [MEDICINE.ACTION_LIST_MEDICINES]: ({commit}, param) => {
    const qs = queryString.stringify(param, {arrayFormat: 'bracket'});
    return get(`/medicine?${qs}`).then((res) => {
      commit(MEDICINE.MUTATE_LIST_MEDICINE, res.data);
    })
  },

  [MEDICINE.ACTION_ADD]: ({commit}, payload) => {
    return post('/medicine', payload);
  },

  [MEDICINE.ACTION_DELETE]: ({commit}, payload) => {
    return del(`/medicine/${payload.id}`);
  },

  [MEDICINE.ACTION_UPDATE]: ({commit}, payload) => {
    return put(`/medicine/${payload.id}`, payload);
  },

  [MEDICINE.ACTION_AGGREGATE]: ({commit}, payload) => {
    const qs = queryString.stringify(payload, {arrayFormat: 'bracket'});
    return get(`/medicine/aggregate?${qs}`);
  }
}



// WEBPACK FOOTER //
// ./src/store/medicine/actions.js